import $ from "jquery";
import "slick-carousel";

import 'swiper/swiper-bundle.min.js';

export default class Carousels {
	constructor(){
		this.carousel = {
			multiple_items: document.querySelectorAll('.carousel[data-carousel="multiple-items"]'),
            single_item: document.querySelectorAll('.carousel[data-carousel="single-item"]'),
            thumb_items: document.querySelectorAll('.carousel[data-carousel="thumb-items"]'),
            grid_items: document.querySelectorAll('.carousel[data-carousel="grid-items"]'),
            new_products: document.querySelectorAll('.carousel[data-carousel="new-products"]'),
            news_blog: document.querySelectorAll('.carousel[data-carousel="news-blog"]'),
		};
	}

	init() {
		if(this.carousel.single_item) { this.singleItems(); }
		if(this.carousel.multiple_items) { this.multipleItems(); }
		if(this.carousel.grid_items) { this.gridItems(); }
        if(this.carousel.new_products){ this.newProducts(); }
        if(this.carousel.news_blog){ this.newsBlog(); }

	}

    singleItems = () => {
        this.carousel.single_item.forEach(carousel => {
            var swiper = new Swiper(".thumb-slider", {
    
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesProgress: true,
              });
              var swiper2 = new Swiper(".single-image", {
                loop: true,
                spaceBetween: 10,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                thumbs: {
                  swiper: swiper,
                },
            });
        })
	}


    multipleItems = () => {
        this.carousel.multiple_items.forEach(carousel => {
            var items = carousel.querySelectorAll('.item'),
            scrollbar = carousel.querySelector('.scrollbar');

            if(items) { items.forEach(slide => { slide.classList.add('swiper-slide')}); }

            if(scrollbar) { 
                scrollbar.classList.add('swiper-scrollbar');
                carousel.classList.add('pb-3');
            }

            carousel.parentNode.classList.add('overflow-hidden');

            var swiper = new Swiper(carousel, {
                slidesPerView: 1,
                spaceBetween: 4,
                createElements: true,
                setWrapperSize: true,
                wrapperClass: 'swiper-wrapper',
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
                // pagination: {
                //     el: carousel.querySelector('.pagination'),
                //     clickable: true,
                // },
                scrollbar: {
                    el: carousel.querySelector('.scrollbar'),
                    draggable: true,
                    // hide: true,
                },
                mousewheel: {
                    // invert: true,
                    forceToAxis: true,
                },
                breakpoints: {
                    // when window width is >= 480px
                    480: {
                      slidesPerView: 2,
                    },
                    // when window width is >= 640px
                    640: {
                      slidesPerView: carousel.getAttribute('data-items'),
                    }
                  }
            });
        })
    } 

    gridItems = () => {
        this.carousel.grid_items.forEach(carousel => {
            var items = carousel.querySelectorAll('.item');
            
            if(items) { items.forEach(slide => { slide.classList.add('swiper-slide')}); }
            
            
            var wrapper = '<div class="swiper-wrapper">' + carousel.innerHTML + '<div class="scrollbar"></div></div>';
            
            carousel.innerHTML = wrapper;
            carousel.parentNode.classList.add('overflow-hidden');
            
            var scrollbar = carousel.querySelector('.scrollbar');

            if(scrollbar) { 
                scrollbar.classList.add('swiper-scrollbar');
                carousel.append(scrollbar);
                carousel.querySelector('.scrollbar').remove();
                carousel.classList.add('pb-3');
            }

            var swiper = new Swiper(carousel, {
                slidesPerView: 1,
                grid: {
                    fill: 'row',
                    rows: 1,
                },
                spaceBetween: 4,
                scrollbar: {
                    el: carousel.querySelector('.scrollbar'),
                    draggable: true,
                    // hide: true,
                },
                mousewheel: {
                    // invert: true,
                    forceToAxis: true,
                },
                breakpoints: {
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 2,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: carousel.getAttribute('data-items'),
                        grid: {
                            fill: 'row',
                            rows: 2,
                        },
                    }
                  }
            });
        })
    } 

	_multipleItems = () => {
        var carousel = $('.carousel[data-carousel="multiple-items"]');
        
        carousel.each(function(){
            var arrowsContainer = '<div class="arrows-only"></div>';
            $(this).parent().append(arrowsContainer);
            
            $(this).not('.slick-initialized').slick({
                mobileFirst: true,
                arrows: false,
                prevArrow: '<button type="button" class="btn-prev"></button>',
                nextArrow: '<button type="button" class="btn-next"></button>',
                dots:true,
                appendArrows: $(this).parent().find('.arrows-only'),
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                autoplay: false,
                responsive: [{
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 6,
                    }
                }],
            });
        })
    }

    newProducts = () => {
        this.carousel.new_products.forEach(carousel => {
            var swiper = new Swiper(carousel, {
    
                spaceBetween: 20,
                slidesPerView: 1,
                freeMode: true,
                watchSlidesProgress: true,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
                infinite: true,
                autoplay: false,
                breakpoints: {
                    // when window width is >= 769px
                    769: {
                        slidesPerView: 4,
                    }
                }
            });
        })
    }

    newsBlog = () => {
        this.carousel.news_blog.forEach(carousel => {
            var swiper = new Swiper(carousel, {
                spaceBetween: 10,
                direction: "vertical",
                grabCursor: true,
                effect: "creative",
                creativeEffect: {
                    prev: {
                    shadow: true,
                    translate: [0, 0, -400],
                    },
                    next: {
                    translate: [0, "100%" , 0],
                    },
                },
                mousewheel: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });
        })
    }
}
